<template>
  <div>
    <wc-data-box
      title='Invoices'
      :titleIcon='icon'
      :titleIconColor='iconColor'
      showHelp
      helpText='These are automatically calculated based on the billing type, start/end dates, and driveway rating selected.'
    >
      <v-simple-table dense>
        <thead>
          <tr>
            <th>Date</th>
            <th>Description</th>
            <th width='70' class='text-right'>Subtotal</th>
            <th width='70' class='text-right'>GST</th>
            <th width='70' class='text-right'>Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for='(p, index) in estimate.payments' :key='index'>
            <td>{{ p.payment_date|shortDate }}</td>
            <td>{{ p.description }}</td>
            <td class='text-right'>
              {{ p.subtotal | dec }}
            </td>
            <td class='text-right'>
              {{ p.gst | dec }}
            </td>
            <td class='text-right'>
              {{ p.total | decMoney }}
            </td>
          </tr>
          <tr v-if='estimate.estimate_detail.billing_type == "A"'>
            <td></td>
            <td><small class='grey--text'>A half month discount will be added to final invoice</small></td>
            <td class='text-right'>
            </td>
            <td class='text-right'>
            </td>
            <td class='text-right'>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </wc-data-box>
  </div>
</template>

<script>
import _ from 'lodash'
import settings from '@/modules/settings/api/settings'

export default {
  name: 'estimate-totals',
  props: {
    estimate: {
      required: true
    }
  },
  data: () => ({
    icon: 'mdi-chart-gantt',
    iconColor: 'success',
    settings: {}
  }),
  computed: {
    tax () {
      return _.multiply(this.settings.tax_rate_perc, this.estimate.amount)
    },
    total () {
      return _.add(this.tax, this.estimate.amount)
    }
  },
  created () {
    this.getSettings()
  },
  methods: {
    async getSettings () {
      this.settings = await settings.getSettings()
    }
  }
}
</script>
